<template>
	<div id="codebar">
		<div class="inner">
			<div class="code">
				<pre class="language-php">
					<h2>Code snippets</h2>
					<code v-if="snippets">
						{{snippets}}
					</code>
				</pre>
			</div>
		</div>
	</div>
</template>

<script>

import Prism from 'prismjs'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import xhrModule from '../modules/xhrModule.js'

export default {
	name: 'Codebar',
	data () {
		return {
			open: false,
			snippets: null
		}
	},

	created () {
		this.body = document.querySelector('body')
	},

	mounted () {
		this.codeEl = this.$el.querySelector('code')
		this.$root.$on('updateCodebar', (id) => {
			this.update(id)
		})
	},

	updated () {
		Prism.highlightAll()
	},

	methods: {
		toggle () {
			if (this.open) {
				this.open = false
				this.body.classList.remove('codebar-active')
			} else {
				this.open = true
				this.body.classList.add('codebar-active')
			}
		},

		fetchSnippetsComplete (data) {
			this.snippets = '\n' + data.data
		},

		update (entityID) {
			this.snippets = null
			var url = '/cms/api/snippets?entity=' + entityID
			xhrModule.get(url, this.fetchSnippetsComplete.bind(this))
		}
	}
}
</script>
